<template>
  <v-dialog content-class="dialog-take-bring" v-model="open" fullscreen hide-overlay transition="dialog-bottom-transition">
    <div class="header">
      <div class="close">
        <v-icon @click="closeDialog()" color="white">mdi-close</v-icon>
      </div>
      <h2>Leva e Traz</h2>
      <div style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">Localização do veículo</div>
    </div>
    <div v-if="(editable && service_order_bring_id) || (bring_address && !service_order_bring_id)" class="map-bring-info">
      <div class="bring-info-image" v-viewer="viewer_options">
        <img v-if="bring_photo_url" class="viewer-preview-helper" :original="bring_photo_url">
        <v-img :src="bring_photo_url" contain></v-img>
      </div>
      <div class="bring-info-address">
        {{ bring_address }}
      </div>
    </div>
    <div>
      <Gmap-Map
        v-if="map.center.lat !== 0"
        style="position: inherit;"
        :zoom="map.zoom"
        :center="map.center"
        :options="{
          zoomControl: false,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          disableDefaultUi: false,
          clickableIcons: false
        }"
      >
        <GmapMarker
          v-if="bring_marker"
          :position="bring_marker"
          :icon="{ url: require('@/assets/maps/checkmarker.png')}"
        />

        <GmapMarker
          v-if="current_marker"
          :position="current_marker"
          :icon="{ url: require('@/assets/maps/current_marker.png')}"
        >
          <GmapInfoWindow opened>
            <div><b>Minha Localização</b></div>
          </GmapInfoWindow>
        </GmapMarker>

      </Gmap-Map>
      <div v-if="(editable && service_order_bring_id) || !service_order_bring_id" class="actions-inside-map">
        <div class="actions-map">
          <div @click="usePlace()" class="action">
            <div class="icon">
              <v-icon size="30px" color="rgba(0, 0, 0, 0.6)">mdi-map-marker-radius</v-icon>
            </div>
            <div class="text">
              Definir Local
            </div>
          </div>
          <div :class="{'action': true, 'disabled': !service_order_bring_id}">
            <input @change="onFileChange($event)" accept="image/*" type='file' class="input-upload" />
            <div class="icon">
              <v-icon size="30px" color="rgba(0, 0, 0, 0.6)">mdi-camera</v-icon>
            </div>
            <div class="text">
              Tirar Foto
            </div>
          </div>
        </div>
        <v-btn
          v-if="service_order_bring_id"
          @click="editable = false"
          class="mt-3"
          block
          color="#48B38B"
          dark
          elevation="0"
          large
        >
          Voltar
        </v-btn>
      </div>
      <div v-else class="preview-location">
        <div class="pl-header">
          <div class="pl-header-image" v-viewer="viewer_options">
            <img v-if="bring_photo_url" :src="bring_photo_url">
          </div>
        </div>
        <div @click="editable = true" class="edit-bring">
          <v-icon>mdi-pencil</v-icon>
        </div>
        <div @click="whatsappContactClient()" class="open-client-whatsapp">
          <v-icon>mdi-whatsapp</v-icon>
        </div>
        <div @click="dialog_open_bring_location = true" class="open-location">
          <v-icon>mdi-directions</v-icon>
        </div>
        <div class="pl-info">
          <div class="client-name">
            {{ client_name }}
          </div>
          <div class="bring-address">
            {{ bring_address }}
          </div>
        </div>
      </div>
    </div>

    <v-dialog
      v-model="dialog_open_bring_location"
      width="500"
    >
      <div class="open-bring-location pa-4">
        <v-btn
          @click="openBringLocation('google')"
          color="primary"
          class="mb-3"
          large
          block
          depressed
          outlined
        >
          <v-icon class="pr-3" size="20px">mdi-google-maps</v-icon> GPS Google
        </v-btn>
        <v-btn
          @click="openBringLocation('ios')"
          color="primary"
          class="mb-3"
          large
          block
          depressed
          outlined
        >
          <v-icon class="pr-3" size="20px">mdi-apple-ios</v-icon> GPS APPLE
        </v-btn>
        <v-btn
          @click="openBringLocation('waze')"
          color="primary"
          class="mb-3"
          large
          block
          depressed
          outlined
        >
          <v-icon class="pr-3" size="20px">mdi-waze</v-icon> GPS Waze
        </v-btn>
        <v-btn
          @click="dialog_open_bring_location = false"
          color="primary"
          large
          block
          depressed
        >
          Cancelar
        </v-btn>
      </div>
    </v-dialog>


    <v-dialog v-model="loading" persistent width="300" class="loader-service-order">
      <v-card class="pt-5 pb-2" color="primary" dark>
        <v-card-text>
          Definindo Localização...
          <v-progress-linear indeterminate color="white" class="mb-0 mt-2"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import { directive as viewer } from "v-viewer"

export default {
  directives: {
    viewer: viewer({
      debug: false
    }),
  },
  props: {
    open: Boolean,
  },
  data: () => ({
    loading: false,
    editable: true,
    c: null,
    place: null,
    map: {
      center: {lat: 0, lng: 0},
      zoom: 14
    },
    bring_marker: null,
    bring_photo: null,
    bring_photo_url: 'https://maps.gstatic.com/tactile/reveal/no_street_view_1x_080615.png',
    bring_address: null,
    viewer_options: { url: 'original', button: false, navbar: true, title: false, toolbar: false, tooltip: true, movable: true, zoomable: true, rotatable: true, scalable: true, transition: true, fullscreen: true, keyboard: true },
    current_marker: null,
    dialog_open_bring_location: false,
    client_name: ''
  }),
  computed: {
    service_order_bring_id() {
      return this.$store.getters['ServiceOrder/service_order_bring_id'];
    },
  },
  mounted() {
    this.getCurrentCoordinates();
    this.client_name = this.$store.getters['ServiceOrder/client_name'];

    const ServiceOrderBring = this.$store.getters['ServiceOrder/service_order_bring'];
    if (ServiceOrderBring) {
      this.editable = false;
      this.bring_address = ServiceOrderBring.address;
      this.bring_photo_url = ServiceOrderBring.photo_url ? ServiceOrderBring.photo_url : 'https://maps.gstatic.com/tactile/reveal/no_street_view_2x_080615.png';
      this.bring_marker = {lat: ServiceOrderBring.marker.coordinates[0], lng: ServiceOrderBring.marker.coordinates[1]};
    }
  },
  methods: {
    getCurrentCoordinates() {
      const self = this;
      self.loading = true;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          if (self.service_order_bring_id) {
            self.map.center = self.bring_marker;
          } else {
            self.map.center = {lat: position.coords.latitude, lng: position.coords.longitude};
          }
          self.loading = false;
        });
        navigator.geolocation.watchPosition(position => {
          const { latitude, longitude } = position.coords;
          self.map.center = {lat: latitude, lng: longitude};
          self.refreshCurrentLocation(latitude, longitude);
          self.loading = false;
        });
      }
    },
    refreshCurrentLocation(lat, lng) {
      this.current_marker = {lat, lng};
    },
    closeDialog() {
      this.$emit('close-dialog');
    },
    setDescription(description) {
      this.description = description;
    },
    setPlace(place) {
      this.place = place
    },
    usePlace() {
      if (this.current_marker) {
        this.bring_marker = {lat: this.current_marker.lat, lng: this.current_marker.lng};
        this.$gmapApiPromiseLazy().then(() => {
          const geocoder = new window.google.maps.Geocoder();
          geocoder.geocode({ location: {lat: this.current_marker.lat, lng: this.current_marker.lng} }, (results, status) => {
            if (status === "OK" && results[0]) {
              this.bring_address = results[0].formatted_address;
              if (!this.service_order_bring_id) {
                this.$store.dispatch('ServiceOrder/createBring', {marker: this.bring_marker, address: this.bring_address});
              } else {
                this.$store.dispatch('ServiceOrder/updateBring', {id: this.service_order_bring_id, marker: this.bring_marker, address: this.bring_address, photo_url: this.bring_photo_url});
              }
            } else {
              console.error("Geocode was not successful for the following reason:", status);
            }
          });
        });
      }
    },
    onFileChange(event) {
      const self = this;

      // eslint-disable-next-line prefer-destructuring
      self.bring_photo = event.target.files[0];
      self.bring_photo_url = URL.createObjectURL(event.target.files[0]);

      const formData = new FormData();
      formData.append('file', self.bring_photo);

      const serviceOrderId = this.$store.getters['ServiceOrder/id'];

      self.loading = true;

      self.$http.patch(`/service_order/${serviceOrderId}/bring/${self.service_order_bring_id}/image`, formData, {
        timeout: 1000 * 120,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((r) => {
        this.$store.dispatch('ServiceOrder/updateBringPhoto', r.data);
        self.loading = false;
      }).catch(() => {
        self.loading = false;
      });
    },
    openBringLocation(platform) {
      if (platform === 'ios') {
        window.open(`http://maps.apple.com/?ll=${this.bring_marker.lat},${this.bring_marker.lng}`)
      } else if (platform === 'waze') {
        window.open(`https://www.waze.com/ul?ll=${this.bring_marker.lat},${this.bring_marker.lng}`)
      } else {
        window.open(`https://www.google.com/maps/search/?api=1&query=${this.bring_marker.lat},${this.bring_marker.lng}`)
      }
    },
    whatsappContactClient() {
      const client = this.$store.getters['ServiceOrder/client'];
      if (client) {
        window.open(`whatsapp://send?phone=55${client.phone.match(/\d+/g).join("")}`)
      }
    },
  },
};
</script>

<style lang="scss">
.gm-ui-hover-effect {
  display: none !important;
}

.gm-style-iw-c {
  padding: 10px 7px !important;
  background-color: #379a77 !important;
  color: #fff !important;
}

.gm-style .gm-style-iw-tc::after {
  background-color: #379a77 !important;
}

.dialog-take-bring {
  .viewer-preview-helper {
    width: -webkit-fill-available;
    height: -webkit-fill-available;
    position: absolute;
    opacity: 0;
    margin: 0 auto;
    z-index: 50;
    overflow: hidden;
  }

  .vue-map {
    margin-top: 100px;
  }

  .header {
    position: fixed;
    width: 100%;
    z-index: 99;
    padding: 20px 20px;
    background-color: #3e515f;
    color: #fff;

    .close {
      float: right;
      background-color: #2d3c47;
      border-radius: 50%;
      padding: 10px;
      margin-top: 5px;
    }
  }

  .actions-inside-map {
    position: fixed;
    bottom: 0px;
    z-index: 9999;
    left: 0;
    padding: 12px 20px;
    width: 100%;
    backdrop-filter: blur(3px) brightness(0.8);
    background-color: rgba(255, 255, 255, 0.4);

    .actions-map {
      width: -webkit-fill-available;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-items: center;
      align-content: stretch;

      .action {
        background-color:  #f5f5f5;
        padding: 10px;
        width: 100%;
        margin: 0 5px;
        border-radius: 6px;
        text-align: center;
        color: rgba(0, 0, 0, 0.6) !important;
        overflow: hidden;
        position: relative;

        &.disabled {
          pointer-events: none !important;
          opacity: 0.8;
        }

        .input-upload {
          opacity: 0;
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          z-index: 98;
          left: 0;
        }

        .text {
          margin-top: 2px;
        }
      }
    }
  }

  .preview-location {
    background-color: #ebeced;
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    overflow: hidden;
    position: fixed;
    bottom: 0px;
    z-index: 9999;
    left: 0;
    width: 100%;

    .pl-header {

      .pl-header-image {
        background-color: #cfcfcf;
        height: 170px;
        width: -webkit-fill-available;
        position: relative;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }

    .edit-bring {
      z-index: 999;
      background-color: #fff;
      height: 50px;
      width: 50px;
      border-radius: 100%;
      padding-top: 12px;
      text-align: center;
      position: fixed;
      margin-top: -160px;
      right: 20px;
      box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    }

    .open-client-whatsapp {
      z-index: 999;
      background-color: #fff;
      height: 50px;
      width: 50px;
      border-radius: 100%;
      padding-top: 12px;
      text-align: center;
      position: fixed;
      margin-top: -26px;
      right: 20px;
      box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    }

    .open-location {
      z-index: 999;
      background-color: #fff;
      height: 50px;
      width: 50px;
      border-radius: 100%;
      padding-top: 12px;
      text-align: center;
      position: fixed;
      margin-top: -26px;
      right: 85px;
      box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    }

    .pl-info {
      width: -webkit-fill-available;
      padding: 26px 20px;

      .client-name {
        font-weight: bold;
        font-size: 20px;
      }

      .bring-address {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 14px;
      }
    }
  }

  .map-bring-info {
    position: fixed;
    width: 100%;
    top: 100px;
    z-index: 99;
    padding: 10px 20px;
    background-color: #ebeced;
    border-bottom: 1px solid #e4e4e4;

    .bring-info-image {
      width: 80px;
      height: 55px;
      overflow: hidden;
      float: left;
      border-radius: 4px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .bring-info-address {
      float: left;
      width: calc(100% - 80px);
      padding: 2px 15px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.open-bring-location {

  .v-btn > .v-btn__content .v-icon {
    position: absolute !important;
    left: 0 !important;
  }
}
</style>
